import COSMOTETemplates from "./cosmote/templates";
import FROGTemplates from "./frog/templates";
import WHATSUPTemplates from "./whatsUp/templates";

const Themes = {
  cosmote: COSMOTETemplates,
  frog: FROGTemplates,
  whatsUp: WHATSUPTemplates
};

export default Themes;
